import { FC } from "react";

interface GapRegionStatusAnnotationProps {
  /** The combined total shown in the tile (gapsClosed / gapsImpact). Null when the tile shows "---" (no out-of-network access points). */
  total?: number | null;
  active?: number;
  pending?: number;
  approved?: number;
  opportunity?: number;
  /** False for older / pre-breakdown-data runs, where only the combined total is shown. */
  useGapsByRegionStatus: boolean;
  testId?: string;
}

/**
 * Secondary "{n} current - {n} opportunity" annotation shown beneath the Closes Gaps / Gap Impact number on the Provider Hub Profiles Key Points tiles.
 */
export const GapRegionStatusAnnotation: FC<GapRegionStatusAnnotationProps> = ({
  total,
  active,
  pending,
  approved,
  opportunity,
  useGapsByRegionStatus,
  testId = "provider-profile__gap-region-status",
}) => {
  if (!useGapsByRegionStatus || total == null) {
    return null;
  }

  const opportunityCount = opportunity ?? 0;
  if (opportunityCount <= 0) {
    return null;
  }

  const currentCount = (active ?? 0) + (pending ?? 0) + (approved ?? 0);

  return (
    <div className="provider-profile__card-breakdown" data-testid={testId}>
      <span className="provider-profile__card-breakdown-part">{currentCount.toLocaleString()} current -</span>{" "}
      <span className="provider-profile__card-breakdown-part">{opportunityCount.toLocaleString()} opportunity</span>
    </div>
  );
};
